<template>
  <div class="platform-data-page">
    <el-form inline class="filter-form-line">
      <el-form-item class="filter-item">
        <el-date-picker
          v-model="month"
          type="daterange"
          :clearable="false"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item class="filter-item">
        <el-button type="primary" @click="handleGetData">确定</el-button>
      </el-form-item>
    </el-form>
    <Plane :type="userIdentity" :data="platformData" />
    <Detail v-if="userIdentity !== 2" :type="userIdentity" :data="agentPlatformData" />
  </div>
</template>

<script>
import Plane from './components/plane_refund.vue'
import Detail from './components/detail_refund.vue'
import { getRefundPlatformData, getRefundPlatformDataList, getAgentRefundPlatformData, getDistributorRefundPlatfromData } from '@/api/organization'
import dayjs from 'dayjs'

export default {
  name: 'RefundPlatformData',

components: { Plane, Detail },
  data() {
    return {
      userIdentity: undefined,
      month: '',
      platformData: {},
      agentPlatformData: [],
    }
  },
  created() {
    this.userIdentity = this.$myStore.state.user.userIdentity
    const today = dayjs().format('YYYY-MM-DD')
    this.month = [today, today]
    this.handleGetData()
  },
  methods: {
    handleGetData () {
      switch (this.userIdentity) {
        case 0:
          this.handleGetPlatformData()
          break
        case 1:
          this.handleGetAgentPlatformData()
          break
        case 2:
          this.handleGetDistributorPlatfromData()
          break
      }
    },
    // 获取平台总数据(超管)
    handleGetPlatformData () {
      const params = {
        startDate: this.month[0],
        endDate: this.month[1]
      }
      Promise.all([getRefundPlatformData(params), getRefundPlatformDataList(params)])
        .then(([res1, res2]) => {
          if (res1.code === 0) {
            this.platformData = res1.data
          }
          if (res2.code === 0) {
            this.agentPlatformData = res2.data
          }
        })
    },
    // 获取平台总数据(教务服务方)
    handleGetAgentPlatformData() {
      const params = {
        startDate: this.month[0],
        endDate: this.month[1]
      }
      getAgentRefundPlatformData(params).then(({ code, data }) => {
        if (code === 0) {
          this.platformData = data
          this.agentPlatformData = data.itemList
          delete this.platformData.itemList
        }
      })
    },
    // 获取平台总数据(招生服务方)
    handleGetDistributorPlatfromData() {
      const params = {
        startDate: this.month[0],
        endDate: this.month[1]
      }
      getDistributorRefundPlatfromData(params).then(({ code, data }) => {
        if (code === 0) {
          this.platformData = data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.platform-data-page {
  ::v-deep .module-title-line {
    padding-bottom: 16px;
    .title-icon {
      display: inline-block;
      width: 28px;
      height: 28px;
      margin-right: 4px;
      background-repeat: no-repeat;
      background-size: contain;
      &.icon-trend {
        background-image: url('../../../assets/images/platform/icon_trend.png');
      }
      &.icon-atom {
        background-image: url('../../../assets/images/platform/icon_atom.png');
      }
    }
    .title-text {
      line-height: 30px;
      font-weight: 600;
      font-size: 20px;
      color: #2F2F2F;
    }
  }
}

.filter-item {
  margin-bottom: 0;
}

@media screen and (max-width: 1500px) {
  .platform-data-page {
    ::v-deep .plane-item-content {
      .content-name {
        font-size: 12px !important;
      }
      .content-num {
        font-size: 20px !important;
      }
    }
    ::v-deep .details-item {
      max-width: 31.87%;
    }
  }
}

</style>
